'use strict';
module.exports = require('./InputSwitch.vue');